import NavigationService from '@/services/isomorphic/NavigationService';
import { makeAutoObservable, observable } from 'mobx';
import { NavigationModel } from '@/services/models/Navigation/NavigationModel';
import type { INavigation } from '@/services/models/Navigation/INavigation';

/**
 * A view model for the navigation data structure.
 *
 * Responsible for holding the navigation data structure and providing methods to interact with it.
 */
export class NavigationVM {
  @observable private _navigationModels: Array<NavigationModel>;

  /** @inheritdoc */
  public get navigationModels(): Array<NavigationModel> {
    return this._navigationModels;
  }

  /**
   * Initializes the view model with the navigation data structure.
   *
   * To fetch the navigation data structure, use the static `initialize` method.
   *
   * @param navigationItems - The navigation data structure.
   */
  public constructor(navigationItems: ReadonlyArray<INavigation>) {
    this._navigationModels = navigationItems.map((item) =>
      NavigationModel.from(item)
    );
    makeAutoObservable(this);
  }

  /**
   * Provides the data from the navigation service to be used in the view model.
   *
   * @returns The navigation data structure.
   */
  public static async initialize(): Promise<ReadonlyArray<INavigation>> {
    return NavigationService.getNavigation();
  }
}
